export default {
  mounted(el, binding) {
    const classToAdd = binding.value;

    const checkVisibility = () => {
      const rect = el.getBoundingClientRect();
      const windowHeight =
        window.innerHeight || document.documentElement.clientHeight;

      const inView =
        rect.width > 0 &&
        rect.height > 0 &&
        rect.top >= 0 &&
        rect.bottom <= windowHeight + 200;

      if (inView) {
        el.classList.add(classToAdd);

        setTimeout(() => {
          el.classList.remove(
            "showElement",
            "hidden",
            "hidden-down",
            "hidden-right",
            "hidden-left",
          );
        }, 800);

        window.removeEventListener("scroll", checkVisibility);
      }
    };

    // Ejecutar al montar
    checkVisibility();

    // Escuchar scroll
    window.addEventListener("scroll", checkVisibility);

    // Limpiar al desmontar
    el._onScrollCleanup = () => {
      window.removeEventListener("scroll", checkVisibility);
    };
  },

  unmounted(el) {
    if (el._onScrollCleanup) {
      el._onScrollCleanup();
    }
  },
};
